var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.blockVariableUrl)?_c('basic-block',{attrs:{"value":_vm.value,"mode":_vm.mode},scopedSlots:_vm._u([{key:"main",fn:function(){return [[_c('image-view',{attrs:{"value":_vm.blockVariableImage}})]]},proxy:true}],null,false,100575469)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }